import { Box, Button, Typography } from '@mui/material';
import { useMsal } from '@azure/msal-react';

export function NotRegisteredPage() {
  const { instance } = useMsal();

  const handleSignOut = () => {
    instance.logoutRedirect();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        gap: 2,
      }}
    >
      <Typography variant="h5" color="text.secondary">
        Account Not Registered
      </Typography>
      <Typography variant="body1" color="text.secondary" textAlign="center">
        Your account is not registered in the system.
        <br />
        Please contact your administrator to request access.
      </Typography>
      <Button variant="contained" onClick={handleSignOut}>
        Sign Out
      </Button>
    </Box>
  );
}

export default NotRegisteredPage;
